import { getAppContext } from "config/AppContext";
import { useContext } from "react";

export default function useAppContext() {
    return getAppContext(useContext);
}
